import { object as yupObject, ref as yupRef, string as yupString } from 'yup';
import 'yup_extensions';
import {
  validateEmail,
  validationMessages,
  validateNumEmployees,
  validatePhoneNumber,
  validatePasswordStrength,
  validateStr,
  validateFirstAndLastName,
} from 'constants/validation_constants';
import trackMessageFromExistingUser from 'packages/signup/analytics/trackMessageFromExistingUser';
import uniqueEmailMessage from './uniqueEmailMessage';

const { companyMessage, emailMessage, firstNameMessage, lastNameMessage, invalidCharsMessage } =
  validationMessages;

const emailSchema = yupString().email(emailMessage).required(emailMessage);

const loginBaseUrl = window?.location?.origin
  ? `${window.location.origin}/login`
  : 'https://app.gusto.com/login';

export const uniqueEmailSchema = api =>
  yupString().test('unique-email', uniqueEmailMessage(loginBaseUrl), async email => {
    const validEmail = await emailSchema.isValid(email);
    if (validEmail) {
      return api('/invite/existing-user-email-lookup', { email })
        .then(isTaken => {
          if (isTaken) {
            trackMessageFromExistingUser('company');
          }
          return !isTaken;
        })
        .catch(() => true);
    }
    return true;
  });

const validationSchema = (fromSSO, ssoEmail) =>
  yupObject().shape({
    companyName: validateStr(companyMessage, 2)
      .noEmailValue(invalidCharsMessage)
      .required(companyMessage),
    email: validateEmail,
    firstName: validateFirstAndLastName(firstNameMessage).required(firstNameMessage),
    lastName: validateFirstAndLastName(lastNameMessage).required(lastNameMessage),
    numberEmployees: validateNumEmployees,
    phone: validatePhoneNumber(),
    password: yupString().when('email', {
      is: val => !(fromSSO && val === ssoEmail),
      then: schema => validatePasswordStrength(schema, 2),
    }),
    passwordConfirmation: yupString().when('email', {
      is: val => !(fromSSO && val === ssoEmail),
      then: schema =>
        schema
          .trim()
          .oneOf([yupRef('password')], 'Passwords do not match.')
          .required('Passwords do not match.'),
    }),
  });

export default validationSchema;
